<template>
    <div id="app">
        <v-app id="inspire">  
            <v-card-title class="justify-center pt-4 pb-0 pl-5 font-weight-black text-uppercase">
                <span class="primary--text">Blue - Pending</span>
                <span class="pl-5 success--text">Green - Completed</span>
                <span class="pl-5 error--text">Red - Cancelled</span>
            </v-card-title>

            <v-container grid-list-md text-xs-center>
                <v-layout row wrap> 
                    <v-flex xs12 sm12 md12 lg12> 
                        <v-layout v-if="showEmpty" row wrap>
                            <v-flex xs12 sm12 md12 lg12>
                                <div class="text-xs-center">
                                    <br><br><br><br>
                                <v-icon size="100">event_busy</v-icon>
                                <v-card-title class="display-2 font-weight-regular justify-center">NO TRANSACTIONS
                                </v-card-title>
                                </div>
                            </v-flex>
                        </v-layout>  
        
                        <v-timeline v-if="showBoards" dense class="pt-0">
                            <v-slide-x-reverse-transition group hide-on-leave>
                                <v-timeline-item v-for="(list, index) in reservedAppointment" :key="index" small :color= list.color >
                                    <v-layout row wrap>
                                        <v-flex d-flex xs12 sm12 md3 lg3>
                                            <v-alert value="true" :color= list.color outline>
                                                <v-card-title class="headline font-weight-bold justify-center">
                                                    {{ list.formatedDate }}
                                                </v-card-title>
                                                <v-list-tile-sub-title class="subheading font-weight-regular justify-center">
                                                    {{ list.appointmentTime }}
                                                </v-list-tile-sub-title>
                                                <br>
                                                <v-list-tile-sub-title class="subheading font-weight-bold justify-center">
                                                    Control Number
                                                </v-list-tile-sub-title>
                                                <v-list-tile-sub-title class="subheading font-weight-regular justify-center">
                                                    {{list.transactionId}}
                                                </v-list-tile-sub-title>
                                                <div v-if="list.color=='blue darken-4' && list.appointmentDate == dateValidate">
                                                    <v-btn v-if="list.serving=='1'" class="subheading font-weight-regular justify-center" dark color="success" @click="queue(list)">
                                                        <v-list-tile-sub-title class="subheading font-weight-bold justify-center"> Now Processing
                                                        </v-list-tile-sub-title> 
                                                    </v-btn>

                                                    <v-btn v-else class="subheading font-weight-regular justify-center" dark color="warning" @click="queue(list)">
                                                        <v-list-tile-sub-title class="subheading font-weight-bold justify-center" >Queue
                                                        </v-list-tile-sub-title>   
                                                    </v-btn>
                                                </div>

                                                <v-btn v-if="list.color=='green darken-4'" class="subheading font-weight-regular justify-center" dark color="blue darken-4" @click="viewDetails(list)">
                                                    <v-list-tile-sub-title class="subheading font-weight-bold justify-center"> VIEW DETAILS
                                                    </v-list-tile-sub-title> 
                                                </v-btn>
                                            </v-alert>
                                        </v-flex>

                                        <v-flex d-flex xs12 sm12 md9 lg9> 
                                            <v-alert value= "true" :color= list.color outline>
                                                <v-layout row wrap>
                                                    <v-flex lg6 xs12>
                                                        <v-card-title class="headline font-weight-medium">
                                                            {{list.userDetails.fullName}}
                                                        </v-card-title>
                                                    </v-flex>
                                                    
                                                    <v-flex lg6 xs12 v-if="list.color=='blue darken-4'" class="pa-0 ma-0"> 
                                                        <v-btn v-if="list.showBtn" dark outline color="blue darken-4" @click="editValidation(list)"> UPDATE
                                                        </v-btn>

                                                        <v-btn dark color="red accent-4" @click="requestForCancellation(list)">NO SHOW</v-btn>
                                                    </v-flex>

                                                    <v-list-tile-sub-title class="body-2 pl-2 text-xs-left font-weight-regular justify-center">
                                                        <v-layout>
                                                            <v-flex xs6 class="pl-5 pr-5"><b>Mobile Number</b> : {{list.userDetails.mobileNumber}}</v-flex>
                                                            <v-flex xs6><b>E-mail Address</b> : {{list.userDetails.email}} </v-flex>
                                                        </v-layout>
                                                    </v-list-tile-sub-title>

                                                    <v-layout>
                                                        <v-card-title class="subheading font-weight-regular"><b>Services</b> : 
                                                            <v-flex xs12 v-for="(service,index) in list.initialService" :key="index">
                                                                <span class="left subheading font-weight-regular">{{service.displayName}}</span> 
                                                            </v-flex> 
                                                        </v-card-title>

                                                        <v-card-title class="subheading font-weight-regular" v-if="list.otherService.length > 0"><b>Others</b> : 
                                                            <v-flex xs12 v-for="(service,index) in list.otherService" :key="index">
                                                                <span class="left subheading font-weight-regular">{{service.service}}</span>  
                                                            </v-flex>
                                                        </v-card-title>
                                                    </v-layout>

                                                    <v-layout>
                                                        <v-flex xs6>
                                                            <v-card-title v-if="list.coupon" class="subheading font-weight-regular">
                                                                <b>Coupon Code</b> : {{ list.coupon }}
                                                            </v-card-title>
                                                            <v-card-title v-else class="subheading font-weight-regular">
                                                                <b>Coupon Code</b> : n/a
                                                            </v-card-title>
                                                        </v-flex>
                                                        <v-flex xs6>
                                                            <v-card-title class="subheading font-weight-regular">
                                                                <b>Mechanic</b> : {{list.mechanic}}
                                                            </v-card-title> 
                                                        </v-flex>
                                                    </v-layout>
                                                </v-layout>
                                            </v-alert>
                                        </v-flex>
                                    </v-layout>
                                </v-timeline-item>
                            </v-slide-x-reverse-transition>
                        </v-timeline>
                    </v-flex>
                </v-layout>
            </v-container>

            <v-dialog v-model="cancelDialog" persistent max-width="500px">
                <v-card>
                    <v-parallax dark class="blue-grey darken-3" height="70">
                        <v-layout>
                            <h4 class="title font-weight-medium pt-3">Are you sure you want to cancel this appointment? </h4>
                        </v-layout>
                    </v-parallax> 

                    <v-card-text class="subheading font-weight-regular">
                       You are about to cancel the selected appointment. This will remove from the list of pending appointments in branch. 
                    </v-card-text>
                    <v-card-text class="subheading font-weight-regular">
                      Are you sure you want to proceed?
                    </v-card-text>
                    
                    <v-card-actions class="justify-center">
                        <v-btn dark color="red accent-4" @click="cancelDialog=false">NO</v-btn>
                        <v-btn dark color="blue darken-4" @click="(cancelAppointment())">YES</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-layout>
                <v-dialog v-model="editDialog" persistent max-width="85%">
                    <v-card>
                        <v-parallax dark class="blue-grey darken-3" height="70">
                            <v-container>
                                <v-layout>
                                    <v-flex xs8>
                                        <v-card-title class="title font-weight-black"> 
                                            {{branch}}
                                        </v-card-title> 
                                    </v-flex>

                                    <v-flex xs4>
                                        <v-card-title class="title font-weight-black"> 
                                            Reference#: <span class="title font-weight-black"> {{forChange.transactionId}}</span>
                                        </v-card-title> 
                                    </v-flex>
                                   
                                    <div class="pl-5">
                                        <v-btn class="pl-3" v-ripple="false" icon dark id="no-background-hover" @click="editDialog=false,customerStats='Show'">
                                            <v-icon class="pl-3">close</v-icon>
                                        </v-btn>
                                    </div>
                                </v-layout>
                            </v-container>
                        </v-parallax> 

                        <v-layout wrap v-if="forChange.userDetails"> 
                            <v-flex xs6 class="pl-3">
                                <v-layout>  
                                <v-card-title class="subtitle-1 font-weight-bold"> 
                                    Job Type*:
                                </v-card-title> 
                                         
                                    <v-flex class="pt-0" v-for="(job,index) in jobTypes" :key="index">
                                        <v-checkbox v-model="selectJobType.jobType" :label="job" :value="job"></v-checkbox>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                        <v-divider></v-divider> 

                        <v-layout>
                            <v-flex xs7 justify-center class="pt-0">
                                <v-container grid-list-sm fluid>
                                    <v-layout row wrap class="justify center">
                                    <v-flex xs7 v-for="(service,index) in serviceMenu" :key="index" class="pt-0">
                                        <v-card-actions class="pt-0 pb-0">
                                            <v-checkbox v-model="selected.service" :label="service.displayName" :value="service"></v-checkbox>
                                        </v-card-actions>
                                        <v-card-title class="caption font-weight-regular pt-0 pb-0">{{service.displayDescription}}
                                        </v-card-title>
                                    </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-flex>

                            <v-flex xs5>
                                <v-container>
                                    <v-card-actions justify-end>
                                        <v-btn color="blue-grey" @click="editDialog=false,changeServiceValidation(forChange)" dark>Save</v-btn>
                                        <v-btn v-if="customerStats=='Show'" color="red accent-4" dark @click="joValidation()">Proceed</v-btn>
                                        <v-btn v-if="customerStats=='Show'" color="blue darken-4" dark @click="requestUpdateMcdetails()">Update Motorcycle Info</v-btn>
                                    </v-card-actions>
                                    
                                    <v-layout wrap v-for="(list,index) in otherServices" :key="index">
                                        <v-flex xs12>
                                            <v-text-field v-model="otherServices[index].service" label="Others" placeholder="Please Specify" required append-outer-icon="cancel" @click:append-outer="removeOtherService(index)"></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-flex xs12 class="pl-0"><v-btn dark outline color="blue darken-4" @click="addOtherServices()">Add Other Services</v-btn></v-flex>

                                    <v-flex xs12>
                                        <v-text-field v-model="coupon" label="Free Service Coupon : " required  prepend-icon="local_offer"></v-text-field>
                                    </v-flex>
                                </v-container>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-dialog>
            </v-layout>

            <v-dialog v-model="editMcDialog" persistent max-width="500px">
                <v-card height="100%">
                    <v-parallax dark class="blue-grey darken-4" height="70">
                        <v-container>
                            <v-layout>
                                <h4 class="subheading font-weight-medium">UPDATE MOTORCYCLE</h4>
                            </v-layout>
                        </v-container>
                    </v-parallax> 
                
                    <v-card-text v-if="forChange.motorcycleDetails">
                        <v-container grid-list-md class="pt-0">
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-flex xs12 sm12 md12>
                                        <v-text-field v-model="dealer" label="Dealer/Store*" required
                                            readonly hide-details
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs12 sm12 md12>
                                        <v-text-field v-model="classification"  label="Classification*" required
                                            readonly hide-details
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs12 sm12 md12>
                                        <v-text-field v-model="make" label="Make/Brand*" required
                                            readonly hide-details
                                        ></v-text-field>
                                    </v-flex>
                                
                                    <v-flex xs12 sm12 md12>
                                        <v-text-field v-model="model" label="Model*" required
                                            readonly hide-details
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs12 sm12 md12>
                                        <v-menu ref="yearModelMenu" :close-on-content-click="false" v-model="yearModelMenu" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                            <v-text-field slot="activator" v-model="yearModel" label="Year Model*" readonly hide-details></v-text-field>
                                            <v-date-picker ref="picker" :max="new Date().toISOString().substr(0, 10)" v-model="yearModel" @input="save" reactive no-title></v-date-picker>
                                        </v-menu>
                                    </v-flex>

                                    <v-flex xs12 sm12 md12>
                                        <v-text-field label="Color*" v-model="mcColor" hide-details
                                        ></v-text-field>
                                    </v-flex>
                                
                                    <v-flex xs12 sm12 md12>
                                        <v-text-field label="Engine Number*" v-model="engineNumber" hide-details
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs12 sm12 md12>
                                        <v-text-field label="Chassis Number*" v-model="chassisNumber" hide-details
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs12 sm12 md12>
                                        <v-text-field label="Plate Number*" v-model="plateNumber" hide-details
                                        ></v-text-field>
                                    </v-flex>

                                    <v-flex xs12 sm12 md12>
                                        <v-menu v-model="dateOfPurchaseMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field v-model="dateOfPurchase" label="Date of Purchase*" readonly v-on="on" hide-details></v-text-field>
                                            </template>
                                            <v-date-picker v-model="dateOfPurchase" @input="dateOfPurchaseMenu=false"></v-date-picker>
                                        </v-menu>
                                    </v-flex>

                                    <v-flex xs12 sm12 md12>
                                        <v-menu v-model="registrationDateMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field v-model="registrationDate" label="Registration Date*" readonly v-on="on" hide-details></v-text-field>
                                            </template>
                                            <v-date-picker v-model="registrationDate" @input="registrationDateMenu=false"></v-date-picker>
                                        </v-menu>
                                    </v-flex>

                                    <v-flex xs12 sm12 md12 class="pb-4">
                                        <v-text-field label="Mileage (KM)*" mask="#######" v-model="odometer" hide-details
                                        ></v-text-field>
                                    </v-flex>

                                    <v-layout justify-center>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn dark color="grey darken-1" @click="editMcDialog=false">Close</v-btn>
                                            <v-btn dark color="blue darken-4" @click="saveRequestedMcDetails()">Save</v-btn>
                                        </v-card-actions>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <v-layout>
                <v-dialog v-model="joDialog" persistent max-width="80%">
                    <v-card>
                        <v-container fluid class="pa-0" grid-list-md>
                            <div id="jo">
                                <v-card-text>
                                    <v-parallax dark class="blue-grey darken-3" height="70">
                                        <v-container>
                                            <v-layout>
                                                <v-flex xs8>
                                                    <v-card-title class="title font-weight-black"> 
                                                        {{branch}}
                                                    </v-card-title> 
                                                </v-flex>

                                                <v-flex xs4>
                                                    <v-card-title class="title font-weight-black"> 
                                                        Reference#: <span class="title font-weight-black"> {{forChange.transactionId}}</span>
                                                    </v-card-title> 
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-parallax> 

                                    <v-layout wrap> 
                                        <v-flex xs4 v-if="forChange.userDetails">
                                            <v-card-title class="subtitle-1 font-weight-bold pb-0"> 
                                                Owner: {{forChange.userDetails.fullName}}
                                            </v-card-title>

                                            <v-card-title v-if="customerDetails.address" class="subtitle-1 font-weight-bold pb-0 pt-0"> 
                                                Address: {{customerDetails.address.brgy}} {{customerDetails.address.city}} {{customerDetails.address.state}}
                                            </v-card-title>

                                            <v-card-title class="subtitle-1 font-weight-bold pt-0 pb-0"> 
                                                Email: {{forChange.userDetails.email}}
                                            </v-card-title>

                                            <v-card-title class="subtitle-1 font-weight-bold pt-0 pb-0"> 
                                                Contact #: {{forChange.userDetails.mobileNumber}}
                                            </v-card-title>

                                            <v-card-title class="subtitle-1 font-weight-bold pt-0 pb-0"> 
                                                Branch Code: {{forChange.branchCode}}
                                            </v-card-title>

                                            <v-card-title v-if="forChange.customerType=='Self-Service'" class="subtitle-1 font-weight-bold pt-0 pb-0"> 
                                                Scheduled Appointment
                                            </v-card-title>

                                            <v-card-title v-else class="subtitle-1 font-weight-bold pt-0 pb-0"> 
                                                Walk-in Appointment
                                            </v-card-title>
                                        </v-flex>

                                        <v-flex xs4>
                                            <v-card-title class="subtitle-1 font-weight-bold pb-0"> 
                                                Dealer: {{mcDetails.dealer}}
                                            </v-card-title>

                                            <v-card-title class="subtitle-1 font-weight-bold pb-0 pt-0"> 
                                                Brand: {{mcDetails.make}}
                                            </v-card-title>

                                            <v-card-title class="subtitle-1 font-weight-bold pb-0 pt-0"> 
                                                Model: {{mcDetails.model}}
                                            </v-card-title>

                                            <v-card-title class="subtitle-1 font-weight-bold pb-0 pt-0"> 
                                                Classification: {{mcDetails.classification}}
                                            </v-card-title>

                                            <v-card-title class="subtitle-1 font-weight-bold pt-0 pb-0"> 
                                                Engine #: {{mcDetails.engineNumber}}
                                            </v-card-title>

                                            <v-card-title class="subtitle-1 font-weight-bold pt-0 pb-0"> 
                                                Chassis #: {{mcDetails.chassisNumber}}
                                            </v-card-title>

                                            <v-card-title class="subtitle-1 font-weight-bold pt-0 pb-0"> 
                                                Plate #: {{mcDetails.plateNumber}}
                                            </v-card-title>

                                            <v-card-title class="subtitle-1 font-weight-bold pt-0 pb-0"> 
                                                Mileage: {{mcDetails.odometer}} km
                                            </v-card-title>
                                        </v-flex>

                                        <v-flex xs4>
                                            <v-card-title class="subtitle-1 font-weight-bold pb-0"> 
                                                Date: {{forChange.formatedDate}}
                                            </v-card-title>

                                            <v-card-title class="subtitle-1 font-weight-bold pt-0 pb-0"> 
                                                Repair Job Start: {{forChange.timein}} 
                                            </v-card-title>

                                            <v-card-title class="subtitle-1 font-weight-bold pt-0 pb-0"> 
                                                Repair Job End: - 
                                            </v-card-title>

                                            <v-card-title class="subtitle-1 font-weight-bold pt-0 pb-0"> 
                                                Job Type:
                                                <v-card-title v-for="(job, index) in selectJobType.jobType" :key="index" class="subtitle-1 font-weight-bold pt-0 pb-0"> 
                                                    {{job}}
                                                </v-card-title> 
                                            </v-card-title> 

                                            <v-flex xs12>
                                                <v-text-field class="pr-3" v-model="tempId" label="Job Order#*:" placeholder="Please Specify" required hide-details></v-text-field>
                                            </v-flex>
                                        </v-flex>
                                    </v-layout>

                                    <v-divider></v-divider>
                                    
                                    <v-layout class="pl-3 pr-3">
                                        <v-flex xs8>
                                            <v-layout v-for="(list,index) in selected.service" :key="index">
                                                <v-flex xs10>
                                                    <v-text-field label="Work Requested" placeholder="Please Specify" required :value="list.displayName" readonly></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout wrap v-for="(list,index) in otherServices" :key="index">
                                                <v-flex xs10>
                                                    <v-text-field v-model="otherServices[index].service" label="Others" placeholder="Please Specify" required readonly></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>

                                        <v-flex xs4>
                                            <v-text-field label="Approved by: " v-model="approvedBy" placeholder="Please Specify" required hide-details></v-text-field>

                                            <v-combobox label="Tested by: " v-model="mechanic" placeholder="Please Specify" required :items="mechanics"
                                            ></v-combobox>

                                            <v-textarea label="Remarks: " v-model="joRemarks" placeholder="Please Specify" required></v-textarea> 

                                            <v-text-field label="Validated by: " v-model="cashier" placeholder="Branch Cashier" required hide-details></v-text-field>  
                                        </v-flex>
                                    </v-layout><br>
                                    <v-divider></v-divider>
                                </v-card-text>
                            </div>

                            <v-layout>
                                <v-spacer></v-spacer>
                                <v-flex xs12>
                                    <v-btn color="red accent-4" @click="joDialog=false" dark>Cancel</v-btn>
                                    <v-btn color="success" dark @click="proceedToPayment(forChange)">Finish Appointment</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </v-dialog>
            </v-layout>

            <v-layout>
                <v-dialog v-model="viewDetailsDialog" persistent max-width="80%">
                    <v-card>
                        <v-container fluid class="pa-0" grid-list-md>
                            <div id="jo">
                                <v-card-text>
                                    <v-parallax dark class="blue-grey darken-3" height="70">
                                        <v-container>
                                            <v-layout>
                                                <v-flex xs8>
                                                    <v-card-title class="title font-weight-black"> 
                                                        {{completedDetails.branch}}
                                                    </v-card-title> 
                                                </v-flex>

                                                <v-flex xs4>
                                                    <v-card-title class="title font-weight-black"> 
                                                        Reference#: <span class="title font-weight-black"> {{completedDetails.transactionId}}</span>
                                                    </v-card-title> 
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-parallax> 

                                    <v-layout wrap> 
                                        <v-flex xs4 v-if="completedDetails.userDetails">
                                            <v-card-title class="subtitle-1 font-weight-bold pb-0"> 
                                                Owner: {{completedDetails.userDetails.fullName}}
                                            </v-card-title>

                                            <v-card-title v-if="customerDetails.address" class="subtitle-1 font-weight-bold pb-0 pt-0"> 
                                                Address: {{customerDetails.address.city}} {{customerDetails.address.state}}
                                            </v-card-title>

                                            <v-card-title class="subtitle-1 font-weight-bold pt-0 pb-0"> 
                                                Email: {{completedDetails.userDetails.email}}
                                            </v-card-title>

                                            <v-card-title class="subtitle-1 font-weight-bold pt-0 pb-0"> 
                                                Contact #: {{completedDetails.userDetails.mobileNumber}}
                                            </v-card-title>

                                            <v-card-title class="subtitle-1 font-weight-bold pt-0 pb-0"> 
                                                Branch Code: {{completedDetails.branchCode}}
                                            </v-card-title>

                                            <v-card-title class="subtitle-1 font-weight-bold pt-0 pb-0"> 
                                                {{completedDetails.customerType}}
                                            </v-card-title>
                                        </v-flex>

                                        <v-flex xs4 v-if="completedDetails.motorcycleDetails">
                                            <v-card-title class="subtitle-1 font-weight-bold pb-0"> 
                                                Dealer: {{completedDetails.motorcycleDetails.dealer}}
                                            </v-card-title>

                                            <v-card-title class="subtitle-1 font-weight-bold pb-0 pt-0"> 
                                                Brand: {{completedDetails.motorcycleDetails.make}}
                                            </v-card-title>

                                            <v-card-title class="subtitle-1 font-weight-bold pb-0 pt-0"> 
                                                Model:{{completedDetails.motorcycleDetails.model}}
                                            </v-card-title>

                                            <v-card-title class="subtitle-1 font-weight-bold pb-0 pt-0"> 
                                                Model:{{completedDetails.motorcycleDetails.classification}}
                                            </v-card-title>

                                            <v-card-title class="subtitle-1 font-weight-bold pt-0 pb-0"> 
                                                Mileage: {{completedDetails.motorcycleDetails.odometer}} km
                                            </v-card-title>
                                        </v-flex>

                                        <v-flex xs4>
                                            <v-card-title class="subtitle-1 font-weight-bold pb-0"> 
                                                Date: {{completedDetails.formatedDate}}
                                            </v-card-title>

                                            <v-card-title class="subtitle-1 font-weight-bold pt-0 pb-0"> 
                                                Repair Job Start: {{completedDetails.timein}} 
                                            </v-card-title>

                                            <v-card-title class="subtitle-1 font-weight-bold pt-0 pb-0"> 
                                                Repair Job End: {{completedDetails.timeout}}  
                                            </v-card-title>

                                            <v-card-title class="subtitle-1 font-weight-bold pt-0 pb-0"> 
                                                Job Type:
                                                <v-card-title v-for="(job, index) in completedDetails.jobType" :key="index" class="subtitle-1 font-weight-bold pt-0 pb-0"> 
                                                    {{job}}
                                                </v-card-title> 
                                            </v-card-title> 

                                            <v-card-title class="subtitle-1 font-weight-bold pt-0 pb-0"> 
                                                Job Order:
                                                <v-card-title v-if="completedDetails.reference" class="subtitle-1 font-weight-bold pt-0 pb-0"> 
                                                    {{completedDetails.reference}}
                                                </v-card-title> 
                                            </v-card-title> 
                                        </v-flex>
                                    </v-layout>

                                    <v-divider></v-divider>
                                    
                                    <v-layout class="pl-3 pr-3">
                                        <v-flex xs8>
                                            <v-layout v-for="(list,index) in completedDetails.initialService" :key="index">
                                                <v-flex xs10>
                                                    <v-text-field label="Work Requested" placeholder="Please Specify" :value="list.displayName" readonly></v-text-field>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout wrap v-for="(list,index) in completedDetails.otherService" :key="index">
                                                <v-flex xs10>
                                                    <v-text-field label="Others" placeholder="Please Specify" :value="list.service" readonly></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>

                                        <v-flex xs4>
                                            <v-text-field label="Approved by: " :value="completedDetails.approver" placeholder="Please Specify" readonly hide-details></v-text-field>

                                            <v-combobox label="Tested by: " :value="completedDetails.mechanic" placeholder="Please Specify" readonly :items="mechanics"
                                            ></v-combobox>

                                            <v-textarea label="Remarks: " :value="completedDetails.remarks" placeholder="Please Specify" readonly></v-textarea> 

                                            <v-text-field label="Validated by: " :value="completedDetails.cashier" placeholder="Branch Cashier" readonly hide-details></v-text-field>  
                                        </v-flex>
                                    </v-layout><br>
                                    <v-divider></v-divider>
                                </v-card-text>
                            </div>

                            <v-layout>
                                <v-spacer></v-spacer>
                                <v-flex xs12>
                                    <v-btn color="red accent-4" @click="viewDetailsDialog=false,completedDetails={}" dark>Close</v-btn>
                                </v-flex>
                            </v-layout>

                        </v-container>
                    </v-card>
                </v-dialog>
            </v-layout>
            <Snackbar v-model="snackbar.show" :type="snackbar.type" :message="snackbar.message" />
            <Progress v-model="progress.show" :message="progress.message" />
        </v-app>
    </div>
</template>

<script>
import _ from 'lodash'
import firebase from "firebase";
import {db} from '../main'
import { mapGetters, mapState } from "vuex";
import { gmapApi } from "vue2-google-maps";
import { setTimeout } from 'timers';
import moment from 'moment'
import Progress from '../extras/Progress.vue'
import Snackbar from '../extras/Snackbar.vue'

export default {
    components: {
        Snackbar,
        Progress
    },
    data: () => ({
        reservedAppointment: [],
        forChange: [],
        serviceMenu: [],
        estimateCharge: 0,
        chargeHolder: [],
        timeHolder: [],
        estimateTime: 0,
        selected: {
            service: []
        },
        branch: "",
        branchCode: "",
        mainCalendar: "",
        coupon: "",
        others: "",
        customerStats: "Show",
        color: "info",
        businessUnits: [],
        drawer : false,
        dateValidate: moment().utcOffset('+0800').toISOString().substr(0, 10),
        timeOrder: [ "09:00AM", "09:30AM", "10:00AM", "10:30AM", "11:00AM", "11:30AM", "01:00PM", "01:30PM", "02:00PM", "02:30PM", "03:00PM", "03:30PM", "04:00PM"],
        showBtn: false,
        showEmpty: false,
        showBoards: false,
        motorcycles: [],
        role: "",
        joDialog: false,
        customerDetails: {},
        mcDetails: {},
        otherServices: [{
            service: "",
            price: 0,
        }],
        editDialog: false,
        actualTimein: null,
        actualTimeout: null,
        menu2: false,
        menu3: false,
        mechanics:[],
        mechanic: "",
        approvedBy: "",
        invoice: "",
        joRemarks: "",
        cashier: "",
        jobTypes: ["Coupon","Regular","Warranty"],
        selectJobType: {
            jobType: []
        },
        serviceMenu: [],
        cancelDialog: false,
        forCancellation: {},
        viewDetailsDialog: false,
        completedDetails: {},
        branchId: "",
        tempId: "",
        editMcDialog: false,
        dealer: "",
        classification: "",
        make: "",
        model: "",
        yearModelMenu: false,
        yearModel: null,
        mcColor: "",
        engineNumber: "",
        chassisNumber: "",
        plateNumber: "",
        dateOfPurchase: null,
        dateOfPurchaseMenu: false,
        registrationDateMenu: false,
        registrationDate: null,
        odometer: "",
        snackbar: {
            responseMessage: "",
            show: false,
            type: "success"
        },
        progress: {
            message: "",
            show: false,
        },
    }),

    methods : {
        showSnackbarMessage(message, success = true) {
            this.snackbar.type = success ? "success" : "error"
            this.snackbar.message = message
            this.snackbar.show = true
        },
        showProgress(message) {
            this.progress.message = message
            this.progress.show = true
        },
        stopProgress() {
            this.progress.show = false
        },
        save(date) {
            this.$refs.yearModelMenu.save(date)
            this.$refs.picker.activePicker = "YEAR"
            this.yearModelMenu = false
        },
        requestUpdateMcdetails() {
            let self = this
            self.editMcDialog = true
            self.dealer = self.mcDetails.dealer
            self.classification = self.mcDetails.classification
            self.make = self.mcDetails.make
            self.model = self.mcDetails.model
            self.yearModel = self.mcDetails.yearModel
            self.mcColor = self.mcDetails.color
            self.engineNumber = self.mcDetails.engineNumber
            self.chassisNumber = self.mcDetails.chassisNumber
            self.plateNumber = self.mcDetails.plateNumber
            self.dateOfPurchase = self.mcDetails.dateOfPurchase
            self.registrationDate = self.mcDetails.registrationDate
            self.odometer = self.mcDetails.odometer
        },
        async saveRequestedMcDetails() {
            let self = this
            if (self.engineNumber === ""){
                self.showSnackbarMessage("Engine number should not be blank", false)
            } else if (self.plateNumber === "") {
                self.showSnackbarMessage("Plate number should not be blank", false)
            } else if (self.odometer === "") {
                self.showSnackbarMessage("Please input current kilometer mileage", false)
            } else if (self.yearModel === "" || self.yearModel === null) {
                self.showSnackbarMessage("Year model should not be blank", false)
            } else if (self.mcColor === "") {
                self.showSnackbarMessage("Color should not be blank", false)
            } else if (self.chassisNumber === "") {
                self.showSnackbarMessage("Chassis Number should not be blank", false)
            } else if (self.dateOfPurchase === "" || self.dateOfPurchase === null) {
                self.showSnackbarMessage("Date of Purchase should not be blank", false)
            } else if (self.registrationDate === "" || self.registrationDate == null) {
                self.showSnackbarMessage("Registration should not be blank", false)
            } else {
                self.showProgress("Updating...")
                await db.collection("McDetails"+self.$stage).doc(self.forChange.motorcycleDetails.id).update({
                    "color": self.mcColor,
                    "yearModel": self.yearModel,
                    "engineNumber": self.engineNumber,
                    "chassisNumber": self.chassisNumber,
                    "plateNumber": self.plateNumber,
                    "odometer": self.odometer,
                    "dateOfPurchase": self.dateOfPurchase,
                    "registrationDate": self.registrationDate,
                }).then(async function() {
                    self.stopProgress()
                    self.showSnackbarMessage("Updated successfully", true)
                    self.editMcDialog = false
                    await self.fetchMcdetails()
                }).catch(function(error) {
                    self.stopProgress()
                    self.showSnackbarMessage("Error Updating document", false)
                    self.editMcDialog = false
                })
            } 
        },
        viewDetails(data) {
            let self = this
            self.completedDetails = data
            self.viewDetailsDialog = true
        },
        requestForCancellation(data) {
            let self = this
            self.forCancellation = data
            self.cancelDialog = true
        },
        async cancelAppointment() {
            let self = this
            self.showProgress("Cancelling Appointment..")
            await db.collection("ServiceBooking"+self.$stage).doc(self.forCancellation.transactionId)
            .update({
                "tag": "No Show",
                "status": "Cancelled",
                "dateModified": moment().format('MMMM Do YYYY, h:mm:ss a'),
            }).then(function() {
                self.cancelDialog = false
                setTimeout(() => {
                    self.forCancellation = {}
                    self.stopProgress()
                    self.showSnackbarMessage("Updated", true)
                }, 500)
            }).catch(function(error){
                console.log(error)
                self.showSnackbarMessage("Error updating document", false)
            })
        },
        print() {
            let self = this
            self.showSnackbarMessage("Finish Appointment", true)
            self.stopProgress()
            window.location.reload()

            let routeData = this.$router.resolve({path: '/job-order', 
            query: {
                transactionId: self.forChange.transactionId,
                address: `${self.customerDetails.address.city}` `${self.customerDetails.address.state}`,
                dealer: self.mcDetails.dealer,
                model: self.mcDetails.model,
                engineNumber: self.mcDetails.engineNumber,
                chassisNumber: self.mcDetails.chassisNumber,
                plateNumber: self.mcDetails.plateNumber,
                odometer: self.forChange.odometer,
                mechanic: self.mechanic,
                estimateCharge: self.estimateCharge,
                approvedBy: self.approvedBy,
                invoice: self.invoice,
                joRemarks: self.joRemarks,
                cashier: self.cashier,
                timeIn: self.actualTimein,
                timeOut: moment().format('h:mm a')
            }})
            window.open(routeData.href, '_blank')
        },
        joValidation() {
            let self = this
            self.mechanic = self.forChange.mechanic
            if (self.selectJobType.jobType.length == 0){
                self.showSnackbarMessage("Required Job Type", false)
            } else if (self.mcDetails.engineNumber===""){
                self.showSnackbarMessage("Please update motorcycle details", false)
            } else {
                self.joDialog=true
                self.editDialog=false
            }
        },
        async getAssign() {
            let self = this
            self.showProgress("Loading Transactions...")
            await firebase.auth().onAuthStateChanged(async function(user) {
                await db.collection("Users"+self.$stage).doc(user.uid)
                .get().then(function(doc) {
                    self.branch = doc.data().assign.split('_')[1].trim()
                    self.branchCode = doc.data().assign.split('_')[0].trim()
                    self.branchId = doc.data().assignId
                }).then(async function() {
                    await self.getTransactions()
                    await self.fetchMechanics()
                }).catch(function(error){
                    console.log(error)
                })
            })
        },
        async fetchMechanics() {
            let self = this
            self.mechanics = []
            await db.collection("Mechanics"+self.$stage)
            .where("branchId","==",self.branchId)
            .where("status","==","Active")
            .get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    self.mechanics.push(doc.data().name)
                })
            })   
        },
        addOtherServices() {
            let self = this 
            self.otherServices.push({
                service: "",
                price: 0,
            })
        },
        chargeEstimate() {
            let self = this;
            self.chargeHolder = [];
            self.timeHolder = [];
            self.selected.service.forEach(function (result) {
                self.chargeHolder.push(Number(result.price))
                self.timeHolder.push(Number(result.time))
            })
            self.otherServices.forEach(function (result) {
                self.chargeHolder.push(Number(result.price))
            })
            self.estimateTime =  (self.timeHolder.reduce(function(a, b) { return a + b; }, 0));
            self.estimateCharge = (self.chargeHolder.reduce(function(a, b) { return a + b; }, 0));
            self.estimateCharge = Number(self.estimateCharge)

            var nf = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'Php',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
            nf.format(self.estimateCharge);
            self.estimateCharge = nf.format(self.estimateCharge)
        },
        async getTransactions() {
            let self = this
            self.showProgress("Loading Transactions...")
            await db.collection("ServiceBooking"+self.$stage)
            .where("branchId","==",self.branchId)
            .orderBy("transactionId")
            .onSnapshot(function(querySnapshot) {
                var branchReserved = []
                var validateReserved = []
                var allReservedAppointment = []
                var temp = []
                self.reservedAppointment = []

                querySnapshot.forEach(function(doc) {
                    branchReserved.push(doc.data())
                    self.reservedAppointment.push(doc.data())
                })
                
                if(self.reservedAppointment.length === 0) {
                    self.showEmpty = true
                    self.showBoards = false
                }

                branchReserved.forEach(function(res){
                    self.color="blue darken-4"
                    if(res.status == "Waiting") {
                        validateReserved.push(res)
                    }
                    self.reservedAppointment = []
                    allReservedAppointment = []
                    temp = []

                    validateReserved.forEach(function(result) {
                        if(result.appointmentDate >= self.dateValidate) {
                            allReservedAppointment.push(result)
                        }
                    })
                    
                    branchReserved.forEach(function(res) {
                        if(res.appointmentDate == self.Auth.date) {
                            temp.push(res)
                        }
                    })

                    temp.forEach(function(res) {
                        if(res.status !== "ForApproval" && res.status !== "Rejected"){
                            self.reservedAppointment.push(res)
                        }
                    })

                    if (self.reservedAppointment.length < 1) {
                        self.showEmpty = true
                        self.showBoards = false
                    } else {
                        var color=""
                        self.showEmpty = false
                        self.showBoards = true
                        self.reservedAppointment.forEach(function(data){
                            if(data.status=="Waiting"){
                                color="blue darken-4"
                                self.showBtn = true
                                data.color = color
                                data.showBtn = self.showBtn
                            } else if (data.status == "Cancelled") {
                                color="red darken-2"
                                data.color = color
                            } else if (data.status == "Completed" && data.tag == "Show"){
                                color="green darken-4"
                                data.color = color
                            } else if (data.status == "Completed" && data.tag == "No Show"){
                                color="orange darken-4"
                                data.color = color
                            }
                        })
                    }

                    self.reservedAppointment.sort((a, b) => self.timeOrder.indexOf(a.appointmentTime) - self.timeOrder.indexOf(b.appointmentTime))
                    var data = []
                    var count = 0
                    if (self.reservedAppointment) {
                        self.reservedAppointment.forEach(function(res) {
                            if (res.color == "blue darken-4") {
                                data.push(res)
                                count ++
                            }
                        })

                        if (count == data.length) {
                            data.reverse()
                            data.forEach(function(doc) {
                                self.reservedAppointment.splice(self.reservedAppointment.indexOf(doc),1)
                                self.reservedAppointment.unshift(doc)
                            })
                        }
                    }
                })
                setTimeout(() => {
                    self.stopProgress()
                }, 500)
            })  
        },

        async fetchCustomerDetails(uid, mobileNumber) {
            let self = this
            self.customerDetails = {}
            self.mcDetails = {}
            if (uid) {
                await db.collection("Users"+self.$stage).doc(uid)
                .get().then(function(doc){
                    if(doc.exists){
                        self.customerDetails = doc.data()
                    }
                }).then(async function() {
                    await self.fetchMcdetails()
                    if (self.mcDetails) {
                        self.fetchServiceMenuPerClass()
                    }
                })
            } else {
                await db.collection("WalkinCustomers"+self.$stage).where("mobileNumber","==",mobileNumber)
                .get().then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        self.customerDetails = doc.data()
                    })
                }).then(async function() {
                    self.mcDetails = self.forChange.motorcycleDetails
                    if (self.mcDetails) {
                        await self.fetchServiceMenuPerClass()
                    }
                })
            }
        },
        async fetchMcdetails() {
            let self = this
            self.mcDetails = {}
            await db.collection("McDetails"+self.$stage).doc(self.forChange.motorcycleDetails.id)
            .get().then(function(doc){
                if(doc.exists){
                    self.mcDetails = doc.data()
                }
            })
        },
        changeServiceValidation(forChange) {
            let self = this
            self.showProgress("Updating...")
            self.customerStats = "Show" ? self.changeService("Waiting",forChange.serving,forChange) : self.changeService("Cancelled","0",forChange)
        },
        async changeService(status,serving,forChange) {
            let self = this
            await db.collection("ServiceBooking"+self.$stage).doc(forChange.transactionId)
            .update({
                "jobType": self.selectJobType.jobType,
                "tag": self.customerStats,
                "status": status,
                "initialService": self.selected.service,
                "otherService": self.otherServices,
                "estimateCharge": self.estimateCharge,
                "coupon": self.coupon,
                "serving": serving,
                "dateModified": moment().format('MMMM Do YYYY, h:mm:ss a'),
            }).then(function(doc) {
                setTimeout(() => {
                    self.stopProgress()
                    self.showSnackbarMessage("Updated", true)
                }, 500)
            }).catch(function(error){
                console.log(error)
                self.showSnackbarMessage("Error updating document", false)
            })
        },
        async proceedToPayment(forChange) {
            let self = this
            if (self.mechanic == ""){
                self.showSnackbarMessage("Tested by / Mechanic should not be blank", false)
            } else if (self.approvedBy == "") {
                self.showSnackbarMessage("Approved by should not be blank", false) 
            } else if (self.tempId == "") {
                self.showSnackbarMessage("Job Order# should not be blank", false)
            } else {
                self.showProgress("Updating...")
                self.joDialog=false
                self.actualTimeout = moment().format('h:mm a')

                await db.collection("ServiceBooking"+self.$stage).doc(forChange.transactionId)
                .update({
                    "reference": self.tempId,
                    "jobType": self.selectJobType.jobType,
                    "tag" : self.customerStats,
                    "status": "Completed",
                    "initialService": self.selected.service,
                    "otherService": self.otherServices,
                    "estimateCharge": self.estimateCharge,
                    "coupon": self.coupon,
                    "serving": "0",
                    "timeout": self.actualTimeout,
                    "mechanic": self.mechanic,
                    "approver": self.approvedBy,
                    "invoice": self.invoice,
                    "remarks": self.joRemarks,
                    "cashier": self.cashier,
                    "dateModified": moment().format('MMMM Do YYYY, h:mm:ss a'),
                }).then(async function(doc) {
                    await self.updateMcDetails(forChange)
                    setTimeout(() => {
                        self.stopProgress()
                        self.showSnackbarMessage("Updated", true)
                    }, 1000)
                }).catch(function(error){
                    console.log(error)
                })
            }
        },
        async processMcDetails(motorcycle,forChange,id) {
            let self = this
            var newMcDetails = null
            var newOdo = null
            var history = {}

            self.mcDetails.odometer = self.forChange.odometer
            self.mcDetails.transactions.push(self.forChange.transactionId)

            if(forChange.userDetails.uid) {
                await db.collection("McDetails"+self.$stage).doc(self.mcDetails.id)
                .update({
                   "transactions": self.mcDetails.transactions,
                    "odometer": self.forChange.odometer
                }).then(function(res) {
                    self.showSnackbarMessage("Finish Appointment", true)
                    self.stopProgress()
                    setTimeout(() => {
                        window.location.reload()
                    }, 500)
                }).catch(function(error){
                    console.log(error)
                })
            } else {
                await db.collection("WalkinCustomers"+self.$stage).doc(id)
                .update({
                    "status": "Completed"
                }).then(async function() {
                    await db.collection("McDetails"+self.$stage).doc(self.mcDetails.id)
                    .update({
                        "transactions": self.mcDetails.transactions,
                        "odometer": self.forChange.odometer
                    }).then(function() {
                        self.showSnackbarMessage("Finish Appointment", true)
                        self.stopProgress()
                        setTimeout(() => {
                            window.location.reload()
                        }, 500)
                    }).catch(function(error){
                        console.log(error)
                    })
                }).catch(function(error) {
                    console.log(error)
                })
            }   
        },
        async updateMcDetails(forChange) {
            let self = this
            if (forChange.userDetails.uid) {
                await self.processMcDetails(self.mcDetails,forChange,"Invalid")
            } else {
                var id = ""
                await db.collection("WalkinCustomers"+self.$stage).where("mobileNumber", "==", forChange.userDetails.mobileNumber)
                .get().then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        id = doc.id
                    })
                }).then(async function() {
                    await self.processMcDetails(self.mcDetails,forChange,id)
                })
            }
        },
        async queue(id) {
            let self = this
            self.actualTimein = moment().format('h:mm a')
            id.serving == "0" ? await self.updateOnQueue(id,"1",self.actualTimein) : await self.updateOnQueue(id,"0",null) 
        },
        async updateOnQueue(id,serving,actualTimein) {
            let self = this
            self.showProgress("Updating...")
            await db.collection("ServiceBooking"+self.$stage).doc(id.transactionId)
            .update({
                serving: serving,
                timein: actualTimein,
            }).then(async function() {
                await self.getTransactions()
                setTimeout(() => {
                    self.stopProgress()
                }, 500) 
            })
        },
        removeOtherService(index) {
            let self = this 
            self.otherServices.splice(index,1)
        },
        async editValidation(reservedAppointment) {
            let self = this
            let count = 0
            let list = []
            self.serviceMenu = []
            self.customerStats = "Show"

            if (reservedAppointment.timein) {
                await db.collection("ServiceBooking"+self.$stage).doc(reservedAppointment.transactionId)
                .get().then(function(doc) {
                    self.forChange = doc.data()
                    self.coupon = self.forChange.coupon
                    self.others = self.forChange.otherService
                    self.selected.service = self.forChange.initialService
                    self.branch = self.forChange.branch
                    self.mainCalendar = self.forChange.appointmentDate
                    self.otherServices = self.forChange.otherService
                    self.selectJobType.jobType = self.forChange.jobType
                }).then(async function(){
                    await self.fetchCustomerDetails(self.forChange.userDetails.uid, self.forChange.userDetails.mobileNumber)
                }).catch(function(error) {
                    console.log(error)
                    self.dialog=false
                    self.showSnackbarMessage("Error fetching for change", false)
                })
            } else {
                self.showSnackbarMessage("Queue this transaction first", false)
            }
        },
        async fetchServiceMenuPerClass(){
            let self = this
            let list = []
            let count = 0
            self.showProgress("Loading...")
            self.serviceMenu = []
            await db.collection("ServiceMenu"+self.$stage).get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc){
                    if (doc.data().status === "active"){
                        list.push(doc.data())
                    }
                })
            }).then(function(){
                list.forEach(function(result){
                    result.classifications.forEach(function(data){
                        if (data.class === self.mcDetails.classification) {
                            self.serviceMenu.push({
                                jobCode: "",
                                id: result.id,
                                displayName: result.serviceName,
                                displayDescription: result.description,
                                time: data.time,
                                classification: data.class
                            })
                            count ++
                        }
                    })
                })
                if (count === list.length) {
                    self.serviceMenu.sort()
                    self.stopProgress()
                    self.editDialog = true
                }
            }).catch(function(error) {
                console.log(error)
                self.stopProgress()
                self.showSnackbarMessage("Error fetching service menu", false)
            })
        },
    },

    async mounted() {
        await this.getAssign()
    },

    computed: {
        google: gmapApi,
        ...mapGetters(["user"]),
        ...mapState(["Auth"]),
    },

    watch: {
        yearModelMenu (val) {
            val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"))
        },

        yearModel (val) {
            let self = this
            if (val !== ""){
                self.yearModel = val.split('-')[0].trim()
            }
        },

        selected: {
           handler: function(newValue) {
                this.chargeEstimate()
           },
           deep: true
        },

        otherServices: {
           handler: function(newValue) {
                this.chargeEstimate()
           },
           deep: true
        },

        additionalFee(val) {
            this.chargeEstimate()
        },

        Auth: {
            handler: function(newValue) {
                this.getTransactions()
           },
           deep: true
        }
    },
}


</script>

<style>
    .scrollCard {
        overflow-y: auto
    }

    #no-background-hover::before {
        background-color: transparent
    }

</style>
